// W5 Activate MCM: the module contract (features/README.md). Exports exactly routes, navigation and permissions.
import type { FeatureModule } from '@care-platform/shell';
import { Zap } from 'lucide-react';

// The wizard also reads clients (find client) and devices (link device); activating is what the screen needs.
export const permissions: FeatureModule['permissions'] = [
  'activations.create',
  'clients.read',
  'devices.read',
];

export const routes: FeatureModule['routes'] = [
  { id: 'activation.start', path: '', load: () => import('./activate-mcm-page') },
  { id: 'activation.forClient', path: ':clientId', load: () => import('./activate-mcm-page') },
];

export const navigation: FeatureModule['navigation'] = [
  {
    id: 'activation',
    routeId: 'activation.start',
    label: (copy) => copy.nav.activateMcm,
    icon: Zap,
    pillar: 'clinical',
    permission: 'activations.create',
    order: 30,
  },
];
